import { render } from "./FolderList.vue?vue&type=template&id=bbeaf58a&scoped=true"
import script from "./FolderList.vue?vue&type=script&lang=js"
export * from "./FolderList.vue?vue&type=script&lang=js"

import "./FolderList.vue?vue&type=style&index=0&id=bbeaf58a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbeaf58a"]])

export default __exports__